import { render, staticRenderFns } from "./tableItemsForLesson.vue?vue&type=template&id=332e77ff"
import script from "./tableItemsForLesson.vue?vue&type=script&lang=js"
export * from "./tableItemsForLesson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports